var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      attrs: { type: "border-card" },
      on: { "tab-click": _vm.handleClick },
      model: {
        value: _vm.objData.repType,
        callback: function ($$v) {
          _vm.$set(_vm.objData, "repType", $$v)
        },
        expression: "objData.repType",
      },
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { name: "text" } },
        [
          _c("span", { attrs: { slot: "label" }, slot: "label" }, [
            _c("i", { staticClass: "el-icon-document" }),
            _vm._v(" 文本"),
          ]),
          _c("el-input", {
            attrs: { type: "textarea", rows: 5, placeholder: "请输入内容" },
            model: {
              value: _vm.objData.repContent,
              callback: function ($$v) {
                _vm.$set(_vm.objData, "repContent", $$v)
              },
              expression: "objData.repContent",
            },
          }),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { name: "image" } },
        [
          _c("span", { attrs: { slot: "label" }, slot: "label" }, [
            _c("i", { staticClass: "el-icon-picture" }),
            _vm._v(" 图片"),
          ]),
          _c(
            "el-row",
            [
              _vm.objData.repUrl
                ? _c(
                    "div",
                    { staticClass: "select-item" },
                    [
                      _c("img", {
                        staticClass: "material-img",
                        attrs: { src: _vm.objData.repUrl },
                      }),
                      _vm.objData.repName
                        ? _c("p", { staticClass: "item-name" }, [
                            _vm._v(_vm._s(_vm.objData.repName)),
                          ])
                        : _vm._e(),
                      _c(
                        "el-row",
                        { staticClass: "ope-row" },
                        [
                          _c("el-button", {
                            attrs: {
                              type: "danger",
                              icon: "el-icon-delete",
                              circle: "",
                            },
                            on: { click: _vm.deleteObj },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.objData.repUrl
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "el-col",
                            { staticClass: "col-select", attrs: { span: 12 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.openMaterial },
                                },
                                [
                                  _vm._v("素材库选择"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-circle-check el-icon--right",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { staticClass: "col-add", attrs: { span: 12 } },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: _vm.actionUrl,
                                    headers: _vm.headers,
                                    multiple: "",
                                    limit: 1,
                                    "on-success": _vm.handleUploadSuccess,
                                    "file-list": _vm.fileList,
                                    "before-upload": _vm.beforeImageUpload,
                                    data: _vm.uploadData,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary" } },
                                    [_vm._v("上传图片")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [
                                      _vm._v(
                                        "\n                支持bmp/png/jpeg/jpg/gif格式，大小不超过2M\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "选择图片",
                    visible: _vm.dialogImageVisible,
                    width: "90%",
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogImageVisible = $event
                    },
                  },
                },
                [
                  _c("WxMaterialSelect", {
                    attrs: { "obj-data": _vm.objData },
                    on: { selectMaterial: _vm.selectMaterial },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { name: "voice" } },
        [
          _c("span", { attrs: { slot: "label" }, slot: "label" }, [
            _c("i", { staticClass: "el-icon-phone" }),
            _vm._v(" 语音"),
          ]),
          _c(
            "el-row",
            [
              _vm.objData.repName
                ? _c(
                    "div",
                    { staticClass: "select-item2" },
                    [
                      _c("p", { staticClass: "item-name" }, [
                        _vm._v(_vm._s(_vm.objData.repName)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "item-infos" },
                        [
                          _c("WxVoicePlayer", {
                            attrs: {
                              "obj-data": Object.assign(_vm.tempPlayerObj, {
                                repMediaId: _vm.objData.media_id,
                                repName: _vm.objData.repName,
                              }),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "ope-row" },
                        [
                          _c("el-button", {
                            attrs: {
                              type: "danger",
                              icon: "el-icon-delete",
                              circle: "",
                            },
                            on: { click: _vm.deleteObj },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.objData.repName
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "el-col",
                            { staticClass: "col-select", attrs: { span: 12 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.openMaterial },
                                },
                                [
                                  _vm._v("素材库选择"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-circle-check el-icon--right",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { staticClass: "col-add", attrs: { span: 12 } },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: _vm.actionUrl,
                                    headers: _vm.headers,
                                    multiple: "",
                                    limit: 1,
                                    "on-success": _vm.handleUploadSuccess,
                                    "file-list": _vm.fileList,
                                    "before-upload": _vm.beforeVoiceUpload,
                                    data: _vm.uploadData,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary" } },
                                    [_vm._v("点击上传")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [
                                      _vm._v(
                                        "\n                格式支持mp3/wma/wav/amr，文件大小不超过2M，播放长度不超过60s\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "选择语音",
                    visible: _vm.dialogVoiceVisible,
                    width: "90%",
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVoiceVisible = $event
                    },
                  },
                },
                [
                  _c("WxMaterialSelect", {
                    attrs: { "obj-data": _vm.objData },
                    on: { selectMaterial: _vm.selectMaterial },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { name: "video" } },
        [
          _c("span", { attrs: { slot: "label" }, slot: "label" }, [
            _c("i", { staticClass: "el-icon-share" }),
            _vm._v(" 视频"),
          ]),
          _c(
            "el-row",
            [
              _c("el-input", {
                attrs: { placeholder: "请输入标题" },
                model: {
                  value: _vm.objData.repName,
                  callback: function ($$v) {
                    _vm.$set(_vm.objData, "repName", $$v)
                  },
                  expression: "objData.repName",
                },
              }),
              _c("div", { staticStyle: { margin: "20px 0" } }),
              _c("el-input", {
                attrs: { placeholder: "请输入描述" },
                model: {
                  value: _vm.objData.repDesc,
                  callback: function ($$v) {
                    _vm.$set(_vm.objData, "repDesc", $$v)
                  },
                  expression: "objData.repDesc",
                },
              }),
              _c("div", { staticStyle: { margin: "20px 0" } }),
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _vm.objData.repUrl
                  ? _c(
                      "a",
                      { attrs: { target: "_blank", href: _vm.objData.repUrl } },
                      [
                        _c("i", { staticClass: "icon-bofang" }, [
                          _vm._v(" 播放视频"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticStyle: { margin: "20px 0" } }),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.openMaterial },
                    },
                    [
                      _vm._v("素材库选择"),
                      _c("i", {
                        staticClass: "el-icon-circle-check el-icon--right",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "选择视频",
                    visible: _vm.dialogVideoVisible,
                    width: "90%",
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVideoVisible = $event
                    },
                  },
                },
                [
                  _c("WxMaterialSelect", {
                    attrs: { "obj-data": _vm.objData },
                    on: { selectMaterial: _vm.selectMaterial },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { name: "news" } },
        [
          _c("span", { attrs: { slot: "label" }, slot: "label" }, [
            _c("i", { staticClass: "el-icon-news" }),
            _vm._v(" 图文"),
          ]),
          _c(
            "el-row",
            [
              _vm.objData.content
                ? _c(
                    "div",
                    { staticClass: "select-item" },
                    [
                      _c("WxNews", {
                        attrs: { "obj-data": _vm.objData.content.newsItem },
                      }),
                      _c(
                        "el-row",
                        { staticClass: "ope-row" },
                        [
                          _c("el-button", {
                            attrs: {
                              type: "danger",
                              icon: "el-icon-delete",
                              circle: "",
                            },
                            on: { click: _vm.deleteObj },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.objData.content
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "el-col",
                            { staticClass: "col-select2", attrs: { span: 24 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.openMaterial },
                                },
                                [
                                  _vm._v("素材库选择"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-circle-check el-icon--right",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "选择图文",
                    visible: _vm.dialogNewsVisible,
                    width: "90%",
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogNewsVisible = $event
                    },
                  },
                },
                [
                  _c("WxMaterialSelect", {
                    attrs: { "obj-data": _vm.objData },
                    on: { selectMaterial: _vm.selectMaterial },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }